import React from "react";
import './MobileNav.css'
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const MobileNav = () => {
    return (
        <div className='mobile-nav-container'>
            <ul className='mobile-nav-links'>
                <li className="mobile-nav-list">
                    <Link className="mobile-nav-link" to="/">Home</Link>
                </li>
                <li className="mobile-nav-list">
                    <Link className="mobile-nav-link" to="/history">History</Link>
                </li>
                <li className="mobile-nav-list">
                    <Link className="mobile-nav-link" to="/trustees">Trustees</Link>
                </li>
                <li className="mobile-nav-list">
                    <Link className="mobile-nav-link" to="/policy">Policy & Guidelines</Link>
                </li>
                <li className="mobile-nav-list">
                    <Link className="mobile-nav-link" to="/apply">Apply</Link>
                </li>
                <li className="mobile-nav-list">
                    <Link className="mobile-nav-link" to="/news">Previous Grants</Link>
                </li>
                <li className="mobile-nav-list">
                    <Link className="mobile-nav-link" to="/contact">Contact & FAQs</Link>
                </li>
            </ul>
        </div>

    )
}

export default MobileNav;